import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        this._onUpdated = (e) => this.recomputeGroup(e.detail.groupId)
        this.element.addEventListener("quotation:line-total-updated", this._onUpdated)
    }

    disconnect() {
        this.element.removeEventListener("quotation:line-total-updated", this._onUpdated)
    }

    add(event) {
        event.preventDefault()
        const template = document.getElementById("quotation-line-template")
        if (!template) return

        const time = new Date().getTime()
        const newIndex = this.element.querySelectorAll("tr").length + 1
        const content = template.innerHTML
            .replace(/INDEX/g, time)

        // Insert new row at the bottom of the table
        const quotation_table = this.element.querySelector("#quotation-lines-table")
        quotation_table.insertAdjacentHTML("beforeend", content)
    }

    addGroup(event) {
        event.preventDefault()
        const tpl = document.getElementById("quotation-group-template")
        if (!tpl) return

        // one unique token used for BOTH the child_index and the DOM key
        const token = `${Date.now()}${Math.floor(Math.random()*1000)}`

        const html = tpl.innerHTML
            .replaceAll("GROUP_DOM_ID", token)  // used in data-group-id + dom_key
            .replaceAll("GROUP_INDEX", token)   // nested attributes index

        const table = this.element.querySelector("#quotation-lines-table")
        const tbody = table.tBodies?.[0] || table
        tbody.insertAdjacentHTML("beforeend", html)
    }

    recomputeAllGroups() {
        const groupRows = this.element.querySelectorAll("[data-group-row]")
        groupRows.forEach((groupRow) => {
            const groupId = groupRow.dataset.groupId
            if (groupId) this.recomputeGroup(groupId)
        })
    }

    recomputeGroupFromEvent(event) {
        const groupRow = event.target.closest("tr[data-group-row]")
        if (!groupRow) return

        const groupId = groupRow.getAttribute("data-group-id")
        this.recomputeGroup(groupId)
    }

    recomputeGroup(groupId) {
        if (!groupId) return

        // 1. Collect visible, non-destroyed children of this group
        const rows = Array.from(
            this.element.querySelectorAll(`tr[data-parent-dom="${groupId}"]`)
        ).filter(el => {
            const isHidden =
                el.classList.contains("hidden") ||
                el.getAttribute("aria-hidden") === "true"

            const destroy = el.querySelector(
                'input[name$="[_destroy]"], input[data-destroy-field]'
            )
            const markedForDestroy = destroy && String(destroy.value) === "1"

            return el.isConnected && !isHidden && !markedForDestroy
        })

        // 2. Sum children subtotals
        let sum = 0
        for (const rowEl of rows) {
            let val = NaN
            const hidden = rowEl.querySelector('input[name*="[subtotal_price]"]')
            if (hidden) val = parseFloat(hidden.value)

            if (Number.isNaN(val)) {
                const td = rowEl.querySelector('[data-quotation-lines-row-target="subtotal"]')
                if (td) {
                    const numeric = (td.textContent || "")
                        .replace(/[^\d.]/g, "")
                        .replace(/(\..*?)\./g, "$1")
                    val = parseFloat(numeric)
                }
            }

            if (!Number.isNaN(val)) sum += val
        }

        // 3. Find the group row
        const groupRow = this.element.querySelector(
            `tr[data-group-row][data-group-id="${groupId}"]`
        )
        if (!groupRow) return

        // 4. Get group quantity
        let quantity = 1
        const qtyEl = groupRow.querySelector('input[name*="[quantity]"]')
        if (qtyEl) quantity = parseFloat(qtyEl.value) || 1

        const total = sum * quantity

        // 5. Update visible total
        const totalEl = groupRow.querySelector("[data-group-total]")
        if (totalEl) totalEl.textContent = `₱${total.toFixed(2)}`

        const computedPriceEl = groupRow.querySelector(
            '[data-quotation-lines-target="computedPrice"]'
        )
        const hiddenPrice = groupRow.querySelector('input[name*="[computed_price]"]')
        if (hiddenPrice && computedPriceEl) {
            computedPriceEl.textContent = `₱${sum.toFixed(2)}`
            hiddenPrice.value = sum.toFixed(2)
        }

        // 6. Update hidden subtotal on the group line
        const hiddenSubtotal = groupRow.querySelector('input[name*="[subtotal_price]"]')
        if (hiddenSubtotal) {
            hiddenSubtotal.value = total.toFixed(2)
        }

        // 7. 🔁 Tell the quotation controller to recompute the grand total
        const quotationEl = this.element.closest('[data-controller~="quotation"]')
        if (quotationEl) {
            const quotationCtrl = this.application.getControllerForElementAndIdentifier(
                quotationEl,
                "quotation"
            )
            if (quotationCtrl && typeof quotationCtrl.computeTotal === "function") {
                quotationCtrl.computeTotal()
            }
        }
    }


    addItemUnderGroup(event) {
        event.preventDefault()

        const btn = event.currentTarget
        const groupDomId = btn.dataset.groupId
        if (!groupDomId) return

        const tpl = document.getElementById("quotation-group-item-template")
        if (!tpl) return

        const table = this.element.querySelector("#quotation-lines-table")
        const tbody = table.tBodies?.[0] || table

        // find the header for this group
        const header = tbody.querySelector(
            `[data-group-row][data-group-id="${groupDomId}"]`
        )
        if (!header) return

        // ONLY present on edit; absent on create
        const parentId = header.dataset.groupRecordId || ""

        // unique nested index for the new item line
        const itemIdx = `${Date.now()}${Math.floor(Math.random() * 1000)}`

        const html = tpl.innerHTML
            .replaceAll("ITEM_INDEX", itemIdx)
            .replaceAll("GROUP_DOM_ID", groupDomId)
            .replaceAll("PARENT_ID", parentId)   // "" on create, real id on edit

        // insert after the last row in this group (header + existing children)
        const groupRows = [
            ...tbody.querySelectorAll(
                `[data-group-row][data-group-id="${groupDomId}"], tr[data-parent-dom="${groupDomId}"]`
            )
        ]
        const lastRow = groupRows[groupRows.length - 1]
        lastRow.insertAdjacentHTML("afterend", html)
    }
}